import { useContext } from "react";

import EditProductCode from "components/Actions/dialogs/ProductCodes/Inline/EditProductCode";
import { useProductCodeInlineActions } from "components/Actions/InlineActions/hooks/useProductCodeInlineActions";
import MainContainer from "components/MainContainer";
import Table from "components/Table";
import AuthContext from "context/auth/authContext";
import { PRODUCT_CODE_COLUMNS } from "shared/constants/columns";
import { ID_TYPE, TABLE_NAMES } from "shared/types/enums";

const ProductCodes = () => {
    const { isAdminManagerUser } = useContext(AuthContext);

    const { inlineActions, rowData, isOpen, closeDialog } =
        useProductCodeInlineActions();

    return (
        <>
            <MainContainer>
                <Table
                    name={TABLE_NAMES.ProductCodes}
                    initialColumns={PRODUCT_CODE_COLUMNS}
                    inlineActions={inlineActions}
                    idType={ID_TYPE.Id}
                    isNotSelectable={!isAdminManagerUser}
                    sortFromNewest
                    hideFilters
                    hasActionBar
                />
            </MainContainer>

            <EditProductCode
                data={rowData}
                isOpen={isOpen}
                close={closeDialog}
            />
        </>
    );
};

export default ProductCodes;
